module.exports = "<div class=item__image-container> <img ng-src=\"{{$ctrl.image}}?output-format=jpeg&output-quality=80&background-color=FFFFFF&downsize=*:400px\" alt={{$ctrl.name}}> <div class=item__image cover-image={{$ctrl.image}}></div> </div> <div class=item__info ng-if=$ctrl.id>{{$ctrl.id}}</div> <div class=item__name ng-if=$ctrl.name>{{$ctrl.name}}</div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/item/item.template.html
// module id = 559
// module chunks = 0